import {
  SanitizedUserInfoObject,
  UserRegistrationStatusEnum,
  UserTypeEnum,
} from "@features/mySph/utils/types";

export const MYSPH_JS_BUNDLE_PATH = import.meta.env.VITE_MYSPH_JS_BUNDLE_PATH;
export const MYSPH_CLIENT_ID = import.meta.env.VITE_MYSPH_CLIENT_ID;
export const ESHOP_DOMAIN = import.meta.env.VITE_ESHOP_DOMAIN;
import BTLogo from "@assets/logo-small-bt.svg";

export const REGISTERED_FLAGS = ["reg_bt"];
export const SUBSCRIBER_FLAGS = ["bts", "bt_all", "bt_iap"];
export const IAP_FLAGS = ["bt_iap"];

export const DEFAULT_USER_INFO: SanitizedUserInfoObject = {
  loginId: "",
  firstName: "",
  lastName: "",
  email: "",
  visitorId: "",
  serviceFlags: [],
  userStatus: UserRegistrationStatusEnum.UNVERIFIED,
  userType: UserTypeEnum.ANONYMOUS,
  visitorcat: 0,
  displayName: "",
};

const MYSPH_CONFIG = {
  clientId: MYSPH_CLIENT_ID,
  providers: ["google", "facebook", "apple", "googleOneTap"],
  language: "en",
  pubId: "bt",
  ssoMode: "manual",
  theme: {
    colors: {
      "color-primary": "#007BAD",
      "color-text-success": "#007BAD",
      "color-text-error": "#D30000",
      "color-text-heading": "#2B2B2B",
      "color-text-support": "#FFFFFF",
      "background-button": "#2B2B2B",
      "background-popup": "#FFFFFF",
    },
    bannerImageURLs: {
      "banner-url": BTLogo,
    },
  },
};

export const MYSPH_CONFIG_STRING = `window.mySPHConfig=${JSON.stringify(MYSPH_CONFIG)}`;
